import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=752320b4&"
import script from "./Order.js?vue&type=script&lang=js&"
export * from "./Order.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports